export const mockListings = [
  // Emin Termal - Yalova (10 ilan)
  {
    id: 1,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 2,
    createdAt: '2025-08-08',
    description:
      "Emin Termal'de 2 haftalık devremülk hakkı. Şifalı termal suları, modern spa merkezi ve huzurlu ortam. Kış ve yaz sezonu kullanım imkanı ile sağlıklı tatil fırsatı.",
    images: [
      'https://public.readdy.ai/ai/img_res/158d7f724f765237cc34b6651d58c7f5.jpg',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20room%20interior%20modern%20furniture%20comfortable%20bed%20clean%20design%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-1-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20outdoor%20thermal%20pool%20garden%20area%20trees%20relaxation%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-1-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20indoor%20thermal%20pool%20blue%20water%20steam%20modern%20spa%20center%20relaxation%20area%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-1-1&orientation=landscape',
    price: 1850000,
    contact_phone: '+90 532 123 4567',
    contact_whatsapp: '+90 532 123 4567',
    season: 'Tüm Sezon',
    unit_type: 'Standart Oda',
    capacity: 2,
    owner_name: 'Ah*** Y***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı ve açık termal havuzlar' },
      { icon: 'ri-spa-line', name: 'Spa Merkezi', description: 'Profesyonel masaj ve bakım hizmetleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Açık büfe kahvaltı ve akşam yemeği' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Tüm alanlarda yüksek hızlı internet' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Ücretsiz kapalı otopark' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Fin saunası ve buhar odası' },
    ],
    activities: [
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova ormanlarında rehberli turlar' },
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-mental-health-line', name: 'Yoga & Meditasyon', description: 'Sabah yoga seansları' },
      { icon: 'ri-bike-line', name: 'Bisiklet Turu', description: 'Çevredeki köylere bisiklet gezileri' },
    ],
  },
  {
    id: 2,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2025-08-10',
    description:
      "Emin Termal'de 1 haftalık devremülk fırsatı. Termal havuz, sauna ve masaj imkanları. Şehrin stresinden uzaklaşmak için ideal kaçış noktası.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20building%20exterior%20entrance%20facade%20modern%20architecture%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-2-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20standard%20room%20interior%20bed%20furniture%20balcony%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-2-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20thermal%20pool%20indoor%20warm%20water%20steam%20spa%20wellness%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-2-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20building%20exterior%20entrance%20facade%20modern%20architecture%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-2-1&orientation=landscape',
    price: 950000,
    contact_phone: '+90 532 234 5678',
    contact_whatsapp: '+90 532 234 5678',
    season: 'Kış Sezonu',
    unit_type: 'Ekonomik Oda',
    capacity: 2,
    owner_name: 'Me*** K***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı termal havuz' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Geleneksel Türk hamamı' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Kahvaltı dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Odada internet erişimi' },
      { icon: 'ri-tv-line', name: 'TV', description: 'Uydu yayınlı LCD tv' },
    ],
    activities: [
      { icon: 'ri-heart-pulse-line', name: 'Termal Banyo', description: 'Şifalı termal su seansları' },
      { icon: 'ri-cup-line', name: 'Çay Saati', description: 'Geleneksel Türk çayı keyfi' },
      { icon: 'ri-book-read-line', name: 'Kütüphane', description: 'Sessiz okuma alanı' },
    ],
  },
  {
    id: 3,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 3,
    createdAt: '2025-08-12',
    description:
      "Emin Termal'de 3 haftalık devremülk hakkı. Geniş aile odası, termal havuz ve çocuk dostu imkanlar. Ailece sağlıklı tatil için mükemmel seçim.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20family%20room%20spacious%20interior%20two%20beds%20modern%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-3-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20thermal%20pool%20area%20families%20children%20warm%20water%20spa%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-3-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20facilities%20restaurant%20dining%20area%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-3-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20family%20room%20spacious%20interior%20two%20beds%20modern%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-3-1&orientation=landscape',
    price: 2750000,
    contact_phone: '+90 532 345 6789',
    contact_whatsapp: '+90 532 345 6789',
    season: 'Tüm Sezon',
    unit_type: 'Aile Odası',
    capacity: 4,
    owner_name: 'Ha*** Ö***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Aile dostu sığ havuz bölümü' },
      { icon: 'ri-gamepad-line', name: 'Çocuk Kulübü', description: 'Animasyon ve oyun alanı' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Çocuk menüsü mevcut' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Geniş aile araçları için uygun' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Tüm alanlarda erişim' },
      { icon: 'ri-first-aid-kit-line', name: 'Bebek Bakım', description: 'Bebek yatağı ve mama sandalyesi' },
    ],
    activities: [
      { icon: 'ri-basketball-line', name: 'Çocuk Aktiviteleri', description: 'Günlük eğlenceli etkinlikler' },
      { icon: 'ri-walk-line', name: 'Aile Yürüyüşü', description: 'Doğada keşif turları' },
      { icon: 'ri-movie-line', name: 'Sinema Gecesi', description: 'Aile filmleri gösterimi' },
      { icon: 'ri-paint-brush-line', name: 'El Sanatları', description: 'Çocuklar için atölye çalışmaları' },
    ],
  },
  {
    id: 4,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 2,
    createdAt: '2025-08-15',
    description:
      "Emin Termal'de 2 haftalık devremülk. Deluxe oda, özel termal jakuzi ve VIP spa hizmetleri. Lüks ve konforlu termal tatil deneyimi.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20deluxe%20room%20luxury%20interior%20king%20bed%20elegant%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-4-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20spa%20massage%20treatment%20room%20wellness%20center%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-4-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20jacuzzi%20bathroom%20luxury%20design%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-4-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20deluxe%20room%20luxury%20interior%20king%20bed%20elegant%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-4-1&orientation=landscape',
    price: 2450000,
    contact_phone: '+90 532 456 7890',
    contact_whatsapp: '+90 532 456 7890',
    season: 'Tüm Sezon',
    unit_type: 'Deluxe Oda',
    capacity: 2,
    owner_name: 'Se*** A***',
    amenities: [
      { icon: 'ri-drop-line', name: 'Özel Jakuzi', description: 'Odada termal jakuzi' },
      { icon: 'ri-spa-line', name: 'VIP Spa', description: 'Özel masaj ve bakım hizmetleri' },
      { icon: 'ri-goblet-line', name: 'Mini Bar', description: 'Ücretsiz içecekler' },
      { icon: 'ri-shirt-line', name: 'Bornoz & Terlik', description: 'Premium kalite' },
      { icon: 'ri-service-line', name: 'Oda Servisi', description: '24 saat hizmet' },
      { icon: 'ri-safe-2-line', name: 'Kasa', description: 'Dijital oda kasası' },
    ],
    activities: [
      { icon: 'ri-hand-heart-line', name: 'Aromaterapi', description: 'Rahatlatıcı yağ masajı' },
      { icon: 'ri-leaf-line', name: 'Çamur Banyosu', description: 'Detoks ve cilt bakımı' },
      { icon: 'ri-wine-line', name: 'Şarap Tadımı', description: 'Yerel şarap deneyimi' },
      { icon: 'ri-moon-line', name: 'Gece Spa', description: 'Özel romantik spa paketi' },
    ],
  },
  {
    id: 5,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2025-08-18',
    description:
      "Emin Termal'de 1 haftalık devremülk hakkı. Yaz sezonu kullanımı, termal havuz ve açık hava aktiviteleri. Doğayla iç içe huzurlu tatil.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20winter%20outdoor%20thermal%20pool%20steam%20cold%20weather%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-5-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20cozy%20room%20winter%20warm%20interior%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-5-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20indoor%20thermal%20pool%20warm%20water%20steam%20winter%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-5-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20winter%20outdoor%20thermal%20pool%20steam%20cold%20weather%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-5-1&orientation=landscape',
    price: 1100000,
    contact_phone: '+90 532 567 8901',
    contact_whatsapp: '+90 532 567 8901',
    season: 'Yaz Sezonu',
    unit_type: 'Standart Oda',
    capacity: 2,
    owner_name: 'Em*** D***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Açık Havuz', description: 'Yaz aylarında açık termal havuz' },
      { icon: 'ri-sun-line', name: 'Güneşlenme Alanı', description: 'Şezlong ve şemsiye' },
      { icon: 'ri-plant-line', name: 'Bahçe', description: 'Yeşil alanlar ve dinlenme köşeleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Teras yemek alanı' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Bahçede de erişim' },
    ],
    activities: [
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova şelalelerine tur' },
      { icon: 'ri-bike-line', name: 'Bisiklet', description: 'Kiralık bisiklet hizmeti' },
      { icon: 'ri-camera-line', name: 'Fotoğraf Turu', description: 'Doğa fotoğrafçılığı' },
      { icon: 'ri-plant-line', name: 'Botanik Bahçe', description: 'Yalova Botanik Bahçesi gezisi' },
    ],
  },
  {
    id: 6,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 2,
    createdAt: '2025-08-20',
    description:
      "Emin Termal'de 2 haftalık devremülk. Suite oda, geniş yaşam alanı ve özel balkon. Konforlu ve ferah tatil deneyimi.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20suite%20room%20living%20area%20spacious%20interior%20modern%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-6-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20suite%20bedroom%20king%20bed%20elegant%20design%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-6-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20indoor%20pool%20panoramic%20windows%20modern%20spa%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-6-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20suite%20room%20living%20area%20spacious%20interior%20modern%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-6-1&orientation=landscape',
    price: 2200000,
    contact_phone: '+90 532 678 9012',
    contact_whatsapp: '+90 532 678 9012',
    season: 'Tüm Sezon',
    unit_type: 'Suite Oda',
    capacity: 3,
    owner_name: 'Bu*** T***',
    amenities: [
      { icon: 'ri-home-smile-line', name: 'Oturma Odası', description: 'Ayrı geniş yaşam alanı' },
      { icon: 'ri-landscape-line', name: 'Balkon', description: 'Manzaralı özel balkon' },
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Öncelikli havuz erişimi' },
      { icon: 'ri-goblet-line', name: 'Mini Bar', description: 'Zengin içecek seçenekleri' },
      { icon: 'ri-tv-line', name: 'Smart TV', description: '55 inç akıllı televizyon' },
      { icon: 'ri-coffee-line', name: 'Çay/Kahve', description: 'Nespresso makinesi' },
    ],
    activities: [
      { icon: 'ri-spa-line', name: 'Spa Paketi', description: 'Günlük spa kullanımı dahil' },
      { icon: 'ri-restaurant-2-line', name: 'Özel Yemek', description: 'Odada romantik akşam yemeği' },
      { icon: 'ri-mental-health-line', name: 'Wellness', description: 'Kişisel wellness programı' },
      { icon: 'ri-ship-line', name: 'Tekne Turu', description: "Marmara'da günbatımı turu" },
    ],
  },
  {
    id: 7,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 4,
    createdAt: '2025-08-22',
    description:
      "Emin Termal'de 4 haftalık devremülk hakkı. Uzun süreli konaklama için ideal, tüm spa hizmetleri dahil. Sağlık ve huzur dolu tatil.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20complex%20aerial%20view%20buildings%20pools%20gardens%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-7-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20comfortable%20room%20long%20stay%20modern%20design%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-7-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20multiple%20thermal%20pools%20spa%20area%20wellness%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-7-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20complex%20aerial%20view%20buildings%20pools%20gardens%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-7-1&orientation=landscape',
    price: 3600000,
    contact_phone: '+90 532 789 0123',
    contact_whatsapp: '+90 532 789 0123',
    season: 'Tüm Sezon',
    unit_type: 'Standart Oda',
    capacity: 2,
    owner_name: 'Ce*** B***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Sınırsız Termal', description: 'Tüm havuzlara sınırsız erişim' },
      { icon: 'ri-spa-line', name: 'Spa Paketi', description: 'Haftalık masaj dahil' },
      { icon: 'ri-restaurant-line', name: 'Tam Pansiyon', description: '3 öğün yemek dahil' },
      { icon: 'ri-shirt-line', name: 'Çamaşırhane', description: 'Ücretsiz çamaşır hizmeti' },
      { icon: 'ri-first-aid-kit-line', name: 'Sağlık Kontrolü', description: 'Haftalık doktor viziti' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Uzun süreli park imkanı' },
    ],
    activities: [
      { icon: 'ri-heart-pulse-line', name: 'Kür Programı', description: '21 günlük termal kür' },
      { icon: 'ri-run-line', name: 'Fitness', description: 'Kişisel antrenör desteği' },
      { icon: 'ri-mental-health-line', name: 'Detoks', description: 'Kapsamlı detoks programı' },
      { icon: 'ri-user-heart-line', name: 'Diyet Danışmanlığı', description: 'Beslenme uzmanı desteği' },
    ],
  },
  {
    id: 8,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2025-08-25',
    description:
      "Emin Termal'de 1 haftalık devremülk. Kış sezonu özel fiyat, kar manzaralı termal keyfi. Soğuk havalarda sıcak termal suların tadını çıkarın.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20winter%20outdoor%20thermal%20pool%20steam%20cold%20weather%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-8-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20cozy%20room%20winter%20warm%20interior%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-8-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20indoor%20thermal%20pool%20warm%20water%20steam%20winter%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-8-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20winter%20outdoor%20thermal%20pool%20steam%20cold%20weather%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-8-1&orientation=landscape',
    price: 850000,
    contact_phone: '+90 532 890 1234',
    contact_whatsapp: '+90 532 890 1234',
    season: 'Kış Sezonu',
    unit_type: 'Ekonomik Oda',
    capacity: 2,
    owner_name: 'Ay*** S***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Sıcak termal sular' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Isınmak için ideal' },
      { icon: 'ri-cup-line', name: 'Sıcak İçecek', description: 'Lobi çay servisi' },
      { icon: 'ri-temp-hot-line', name: 'Merkezi Isıtma', description: 'Sıcak ve konforlu odalar' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Sıcak kış yemekleri' },
    ],
    activities: [
      { icon: 'ri-snowy-line', name: 'Kar Keyfi', description: 'Kış manzarası eşliğinde termal' },
      { icon: 'ri-fire-line', name: 'Şömine Başı', description: 'Sıcak çay ve sohbet' },
      { icon: 'ri-book-read-line', name: 'Kitap Okuma', description: 'Huzurlu kış günleri' },
      { icon: 'ri-movie-line', name: 'Film Gecesi', description: 'Sinema salonu gösterimleri' },
    ],
  },
  {
    id: 9,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 2,
    createdAt: '2025-08-28',
    description:
      "Emin Termal'de 2 haftalık devremülk hakkı. Çift kişilik romantik oda, özel spa paketi dahil. Çiftler için ideal termal kaçamak.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20romantic%20room%20king%20bed%20elegant%20design%20couples%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-9-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20couples%20spa%20massage%20treatment%20room%20wellness%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-9-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20thermal%20pool%20romantic%20atmosphere%20relaxation%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-9-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20romantic%20room%20king%20bed%20elegant%20design%20couples%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-9-1&orientation=landscape',
    price: 1950000,
    contact_phone: '+90 532 901 2345',
    contact_whatsapp: '+90 532 901 2345',
    season: 'Tüm Sezon',
    unit_type: 'Deluxe Oda',
    capacity: 2,
    owner_name: 'Fa*** E***',
    amenities: [
      { icon: 'ri-heart-line', name: 'Romantik Dekor', description: 'Çiftlere özel oda düzeni' },
      { icon: 'ri-drop-line', name: 'Jakuzi', description: 'Odada çift kişilik jakuzi' },
      { icon: 'ri-spa-line', name: 'Çift Masajı', description: 'Yan yana masaj imkanı' },
      { icon: 'ri-champagne-line', name: 'Karşılama', description: 'Şampanya ve meyve tabağı' },
      { icon: 'ri-flower-line', name: 'Çiçek', description: 'Odada taze çiçek' },
      { icon: 'ri-moon-line', name: 'Geç Çıkış', description: 'Öğlene kadar oda kullanımı' },
    ],
    activities: [
      { icon: 'ri-heart-2-line', name: 'Romantik Akşam', description: 'Mum ışığında yemek' },
      { icon: 'ri-ship-line', name: 'Tekne Gezisi', description: 'Özel günbatımı turu' },
      { icon: 'ri-wine-line', name: 'Şarap Tadımı', description: 'Yerel şaraplar' },
      { icon: 'ri-camera-line', name: 'Çift Fotoğrafı', description: 'Profesyonel çekim' },
    ],
  },
  {
    id: 10,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 3,
    createdAt: '2025-08-30',
    description:
      "Emin Termal'de 3 haftalık devremülk hakkı. Kral dairesi, özel termal havuz ve butler hizmeti. En üst düzey lüks termal deneyimi.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20presidential%20suite%20luxury%20living%20area%20bedroom%20elegant%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-10-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20luxury%20suite%20private%20thermal%20pool%20exclusive%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-10-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20luxury%20bathroom%20marble%20jacuzzi%20elegant%20design%20real%20photo%20turkey&width=1200&height=800&seq=emin-real-10-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20presidential%20suite%20luxury%20living%20area%20bedroom%20elegant%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-real-10-1&orientation=landscape',
    price: 4200000,
    contact_phone: '+90 532 012 3456',
    contact_whatsapp: '+90 532 012 3456',
    season: 'Tüm Sezon',
    unit_type: 'Kral Dairesi',
    capacity: 4,
    owner_name: 'De*** Ç***',
    amenities: [
      { icon: 'ri-vip-crown-line', name: 'Butler Hizmeti', description: '24 saat özel hizmetli' },
      { icon: 'ri-water-flash-line', name: 'Özel Havuz', description: 'Dairede termal havuz' },
      { icon: 'ri-home-smile-line', name: 'Geniş Alan', description: '120m² yaşam alanı' },
      { icon: 'ri-restaurant-2-line', name: 'Özel Şef', description: 'İsteğe göre yemek hazırlama' },
      { icon: 'ri-car-line', name: 'Transfer', description: 'VIP araç hizmeti' },
      { icon: 'ri-gift-line', name: 'Hoş Geldin', description: 'Premium karşılama paketi' },
    ],
    activities: [
      { icon: 'ri-helicopter-line', name: 'Helikopter Turu', description: 'Marmara üzerinde uçuş' },
      { icon: 'ri-ship-2-line', name: 'Yat Gezisi', description: 'Özel yat kiralama' },
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Yakın golf sahası transferi' },
      { icon: 'ri-shopping-bag-line', name: 'Alışveriş Turu', description: 'İstanbul günübirlik tur' },
    ],
  },

  // Gerçek Türkiye Devremülk Tesisleri
  {
    id: 11,
    facility_name: 'Limak Limra Hotel',
    location: 'Antalya - Kemer',
    week_count: 2,
    createdAt: '2025-09-01',
    description:
      "Limak Limra Hotel'de 2 haftalık devremülk hakkı. Akdeniz'in incisi Kemer'de özel plaj, aquapark ve her şey dahil tatil keyfi. Ultra her şey dahil konsepti ile lüks tatil.",
    images: [
      'https://readdy.ai/api/search-image?query=limak%20limra%20hotel%20kemer%20antalya%20luxury%20beach%20resort%20mediterranean%20sea%20private%20beach%20palm%20trees%20pools%20modern%20architecture%20turkey%20real%20photo&width=1200&height=800&seq=limra-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=limak%20limra%20hotel%20room%20sea%20view%20balcony%20modern%20furniture%20elegant%20design%20kemer%20antalya%20real%20photo&width=1200&height=800&seq=limra-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=limak%20limra%20hotel%20aquapark%20water%20slides%20pools%20family%20fun%20mediterranean%20beach%20kemer%20turkey%20real%20photo&width=1200&height=800&seq=limra-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=limak%20limra%20hotel%20kemer%20antalya%20luxury%20beach%20resort%20mediterranean%20sea%20private%20beach%20palm%20trees%20pools%20modern%20architecture%20turkey%20real%20photo&width=1200&height=800&seq=limra-real-1&orientation=landscape',
    price: 3200000,
    contact_phone: '+90 533 222 3344',
    contact_whatsapp: '+90 533 222 3344',
    season: 'Yaz Sezonu',
    unit_type: 'Deniz Manzaralı',
    capacity: 3,
    owner_name: 'Öz*** M***',
    amenities: [
      { icon: 'ri-sun-line', name: 'Özel Plaj', description: 'Mavi bayraklı kumsal' },
      { icon: 'ri-water-flash-line', name: 'Aquapark', description: '12 kaydıraklı su parkı' },
      { icon: 'ri-restaurant-line', name: 'Ultra Her Şey Dahil', description: '5 restoran, 7 bar' },
      { icon: 'ri-gamepad-line', name: 'Çocuk Kulübü', description: '4-12 yaş animasyon' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Tam donanımlı spa merkezi' },
      { icon: 'ri-basketball-line', name: 'Spor', description: 'Tenis, voleybol, fitness' },
    ],
    activities: [
      { icon: 'ri-sailboat-line', name: 'Tekne Turu', description: 'Kemer koyları gezisi' },
      { icon: 'ri-bubble-chart-line', name: 'Dalış', description: 'Scuba diving kursu' },
      { icon: 'ri-riding-line', name: 'Safari', description: 'Jeep safari turu' },
      { icon: 'ri-ancient-gate-line', name: 'Antik Kent', description: 'Phaselis gezisi' },
    ],
  },
  {
    id: 12,
    facility_name: 'Rixos Premium Belek',
    location: 'Antalya - Belek',
    week_count: 1,
    createdAt: '2025-09-03',
    description:
      "Rixos Premium Belek'te 1 haftalık devremülk hakkı. Belek'in en prestijli tesisinde ultra lüks tatil. Özel plaj, golf sahası ve dünya standartlarında hizmet.",
    images: [
      'https://readdy.ai/api/search-image?query=rixos%20premium%20belek%20antalya%20luxury%20resort%20hotel%20private%20beach%20golf%20course%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=rixos-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=rixos%20premium%20belek%20luxury%20suite%20room%20elegant%20interior%20king%20bed%20modern%20design%20antalya%20real%20photo&width=1200&height=800&seq=rixos-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=rixos%20premium%20belek%20spa%20wellness%20center%20luxury%20massage%20treatment%20room%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=rixos-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=rixos%20premium%20belek%20antalya%20luxury%20resort%20hotel%20private%20beach%20golf%20course%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=rixos-real-1&orientation=landscape',
    price: 4500000,
    contact_phone: '+90 533 333 4455',
    contact_whatsapp: '+90 533 333 4455',
    season: 'Yaz Sezonu',
    unit_type: 'Suite Oda',
    capacity: 2,
    owner_name: 'Me*** K***',
    amenities: [
      { icon: 'ri-vip-crown-line', name: 'VIP Hizmet', description: 'Butler hizmeti' },
      { icon: 'ri-golf-ball-line', name: 'Golf Sahası', description: '18 delikli şampiyonluk sahası' },
      { icon: 'ri-sun-line', name: 'Özel Plaj', description: 'Kumsal ve pier' },
      { icon: 'ri-restaurant-line', name: 'Ultra Lüks', description: '9 restoran, 12 bar' },
      { icon: 'ri-spa-line', name: 'Spa & Wellness', description: 'Ödüllü spa merkezi' },
      { icon: 'ri-gamepad-line', name: 'Rixy Club', description: 'Çocuk kulübü' },
    ],
    activities: [
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Profesyonel golf kursu' },
      { icon: 'ri-sailboat-line', name: 'Yat Turu', description: 'Özel yat gezisi' },
      { icon: 'ri-spa-line', name: 'Spa Ritüelleri', description: 'Özel spa programları' },
      { icon: 'ri-shopping-bag-line', name: 'Alışveriş', description: 'Lüks butikler' },
    ],
  },
  {
    id: 13,
    facility_name: 'Hillside Beach Club',
    location: 'Muğla - Fethiye',
    week_count: 2,
    createdAt: '2025-09-05',
    description:
      "Hillside Beach Club'da 2 haftalık devremülk hakkı. Fethiye'nin eşsiz doğasında butik otel konsepti. Özel koy, organik mutfak ve huzurlu tatil.",
    images: [
      'https://readdy.ai/api/search-image?query=hillside%20beach%20club%20fethiye%20mugla%20boutique%20resort%20private%20bay%20turquoise%20sea%20pine%20trees%20luxury%20bungalows%20turkey%20real%20photo&width=1200&height=800&seq=hillside-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hillside%20beach%20club%20bungalow%20room%20sea%20view%20terrace%20elegant%20design%20fethiye%20mugla%20turkey%20real%20photo&width=1200&height=800&seq=hillside-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hillside%20beach%20club%20private%20bay%20turquoise%20water%20beach%20loungers%20peaceful%20atmosphere%20fethiye%20turkey%20real%20photo&width=1200&height=800&seq=hillside-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=hillside%20beach%20club%20fethiye%20mugla%20boutique%20resort%20private%20bay%20turquoise%20sea%20pine%20trees%20luxury%20bungalows%20turkey%20real%20photo&width=1200&height=800&seq=hillside-real-1&orientation=landscape',
    price: 3800000,
    contact_phone: '+90 533 444 5566',
    contact_whatsapp: '+90 533 444 5566',
    season: 'Yaz Sezonu',
    unit_type: 'Bungalow',
    capacity: 2,
    owner_name: 'Se*** T***',
    amenities: [
      { icon: 'ri-anchor-line', name: 'Özel Koy', description: 'Sakin turkuaz deniz' },
      { icon: 'ri-leaf-line', name: 'Organik Mutfak', description: 'Kendi bahçesinden ürünler' },
      { icon: 'ri-home-4-line', name: 'Bungalow', description: 'Özel bahçeli bungalow' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Doğal ürünlerle bakım' },
      { icon: 'ri-sailboat-line', name: 'Su Sporları', description: 'Kano, yelken, dalış' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Ege mutfağı' },
    ],
    activities: [
      { icon: 'ri-ship-line', name: 'Tekne Turu', description: '12 Adalar gezisi' },
      { icon: 'ri-bubble-chart-line', name: 'Dalış', description: 'Sualtı keşfi' },
      { icon: 'ri-kayak-line', name: 'Kano', description: 'Koy turları' },
      { icon: 'ri-walk-line', name: 'Likya Yolu', description: 'Trekking turları' },
    ],
  },
  {
    id: 14,
    facility_name: 'Maxx Royal Belek',
    location: 'Antalya - Belek',
    week_count: 1,
    createdAt: '2025-09-08',
    description:
      "Maxx Royal Belek'te 1 haftalık devremülk hakkı. Dünyanın en iyi otellerinden biri. Ultra lüks villalar, özel plaj ve eşsiz hizmet kalitesi.",
    images: [
      'https://readdy.ai/api/search-image?query=maxx%20royal%20belek%20antalya%20ultra%20luxury%20resort%20hotel%20private%20beach%20villas%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=maxx-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=maxx%20royal%20belek%20luxury%20villa%20private%20pool%20elegant%20interior%20modern%20design%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=maxx-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=maxx%20royal%20belek%20gourmet%20restaurant%20fine%20dining%20elegant%20atmosphere%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=maxx-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=maxx%20royal%20belek%20antalya%20ultra%20luxury%20resort%20hotel%20private%20beach%20villas%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=maxx-real-1&orientation=landscape',
    price: 6500000,
    contact_phone: '+90 533 555 6677',
    contact_whatsapp: '+90 533 555 6677',
    season: 'Yaz Sezonu',
    unit_type: 'Villa',
    capacity: 4,
    owner_name: 'Al*** B***',
    amenities: [
      { icon: 'ri-home-smile-line', name: 'Özel Villa', description: 'Havuzlu villa' },
      { icon: 'ri-vip-crown-line', name: 'Butler', description: '24 saat özel hizmetli' },
      { icon: 'ri-restaurant-2-line', name: 'Gourmet', description: 'Michelin yıldızlı şefler' },
      { icon: 'ri-sun-line', name: 'Özel Plaj', description: 'VIP plaj bölümü' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Dünya standartlarında spa' },
      { icon: 'ri-car-line', name: 'Transfer', description: 'Lüks araç hizmeti' },
    ],
    activities: [
      { icon: 'ri-ship-2-line', name: 'Yat', description: 'Özel yat kiralama' },
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Şampiyonluk sahası' },
      { icon: 'ri-helicopter-line', name: 'Helikopter', description: 'Helikopter turları' },
      { icon: 'ri-wine-line', name: 'Şarap Tadımı', description: 'Özel şarap mahzeni' },
    ],
  },
  {
    id: 15,
    facility_name: 'Voyage Belek',
    location: 'Antalya - Belek',
    week_count: 2,
    createdAt: '2025-09-10',
    description:
      "Voyage Belek'te 2 haftalık devremülk hakkı. Belek'in köklü tesislerinden biri. Geniş plaj, aquapark ve aile dostu tatil imkanları.",
    images: [
      'https://readdy.ai/api/search-image?query=voyage%20belek%20golf%20spa%20antalya%20resort%20hotel%20beach%20pools%20aquapark%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=voyage-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=voyage%20belek%20family%20room%20spacious%20interior%20balcony%20sea%20view%20modern%20furniture%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=voyage-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=voyage%20belek%20aquapark%20water%20slides%20pools%20family%20entertainment%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=voyage-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=voyage%20belek%20golf%20spa%20antalya%20resort%20hotel%20beach%20pools%20aquapark%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=voyage-real-1&orientation=landscape',
    price: 2900000,
    contact_phone: '+90 533 666 7788',
    contact_whatsapp: '+90 533 666 7788',
    season: 'Yaz Sezonu',
    unit_type: 'Aile Odası',
    capacity: 4,
    owner_name: 'Ha*** Y***',
    amenities: [
      { icon: 'ri-sun-line', name: 'Geniş Plaj', description: 'Uzun kumsal' },
      { icon: 'ri-water-flash-line', name: 'Aquapark', description: 'Büyük su parkı' },
      { icon: 'ri-gamepad-line', name: 'Çocuk Kulübü', description: 'Geniş aktivite programı' },
      { icon: 'ri-restaurant-line', name: 'Her Şey Dahil', description: '7 restoran' },
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Golf sahası erişimi' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Spa ve wellness' },
    ],
    activities: [
      { icon: 'ri-basketball-line', name: 'Spor', description: 'Tenis, voleybol, futbol' },
      { icon: 'ri-music-2-line', name: 'Animasyon', description: 'Gündüz ve gece şovları' },
      { icon: 'ri-bubble-chart-line', name: 'Dalış', description: 'Dalış okulu' },
      { icon: 'ri-ancient-gate-line', name: 'Tur', description: 'Antik kentler gezisi' },
    ],
  },
  {
    id: 16,
    facility_name: 'Cornelia Diamond',
    location: 'Antalya - Belek',
    week_count: 2,
    createdAt: '2025-09-12',
    description:
      "Cornelia Diamond'da 2 haftalık devremülk hakkı. Belek'in en büyük tesislerinden biri. Golf sahası, aquapark ve zengin aktivite seçenekleri.",
    images: [
      'https://readdy.ai/api/search-image?query=cornelia%20diamond%20golf%20resort%20spa%20belek%20antalya%20luxury%20hotel%20pools%20golf%20course%20beach%20palm%20trees%20turkey%20real%20photo&width=1200&height=800&seq=cornelia-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cornelia%20diamond%20deluxe%20room%20sea%20view%20balcony%20elegant%20furniture%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=cornelia-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cornelia%20diamond%20golf%20course%20green%20fairway%20palm%20trees%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=cornelia-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=cornelia%20diamond%20golf%20resort%20spa%20belek%20antalya%20luxury%20hotel%20pools%20golf%20course%20beach%20palm%20trees%20turkey%20real%20photo&width=1200&height=800&seq=cornelia-real-1&orientation=landscape',
    price: 3400000,
    contact_phone: '+90 533 777 8899',
    contact_whatsapp: '+90 533 777 8899',
    season: 'Yaz Sezonu',
    unit_type: 'Deluxe Oda',
    capacity: 3,
    owner_name: 'Em*** D***',
    amenities: [
      { icon: 'ri-golf-ball-line', name: 'Golf Sahası', description: '27 delikli saha' },
      { icon: 'ri-water-flash-line', name: 'Aquapark', description: 'Büyük su parkı' },
      { icon: 'ri-sun-line', name: 'Plaj', description: 'Özel kumsal' },
      { icon: 'ri-restaurant-line', name: 'Her Şey Dahil', description: '8 restoran, 10 bar' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Geniş spa merkezi' },
      { icon: 'ri-gamepad-line', name: 'Çocuk Kulübü', description: 'Animasyon programı' },
    ],
    activities: [
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Golf dersleri' },
      { icon: 'ri-basketball-line', name: 'Spor', description: 'Çok amaçlı spor sahaları' },
      { icon: 'ri-music-2-line', name: 'Eğlence', description: 'Gece şovları' },
      { icon: 'ri-sailboat-line', name: 'Su Sporları', description: 'Çeşitli su aktiviteleri' },
    ],
  },
  {
    id: 17,
    facility_name: 'Regnum Carya',
    location: 'Antalya - Belek',
    week_count: 1,
    createdAt: '2025-09-15',
    description:
      "Regnum Carya'da 1 haftalık devremülk hakkı. Belek'in en prestijli tesislerinden. Golf sahası, özel plaj ve lüks villalar ile unutulmaz tatil.",
    images: [
      'https://readdy.ai/api/search-image?query=regnum%20carya%20golf%20spa%20resort%20belek%20antalya%20luxury%20hotel%20villas%20pools%20golf%20course%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=regnum-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=regnum%20carya%20luxury%20villa%20private%20pool%20elegant%20interior%20modern%20design%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=regnum-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=regnum%20carya%20spa%20wellness%20center%20luxury%20treatment%20room%20massage%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=regnum-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=regnum%20carya%20golf%20spa%20resort%20belek%20antalya%20luxury%20hotel%20villas%20pools%20golf%20course%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=regnum-real-1&orientation=landscape',
    price: 5200000,
    contact_phone: '+90 533 888 9900',
    contact_whatsapp: '+90 533 888 9900',
    season: 'Yaz Sezonu',
    unit_type: 'Villa',
    capacity: 4,
    owner_name: 'Bu*** K***',
    amenities: [
      { icon: 'ri-home-smile-line', name: 'Villa', description: 'Özel havuzlu villa' },
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Şampiyonluk sahası' },
      { icon: 'ri-vip-crown-line', name: 'VIP Hizmet', description: 'Butler hizmeti' },
      { icon: 'ri-restaurant-2-line', name: 'Gourmet', description: 'A la carte restoranlar' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Lüks spa merkezi' },
      { icon: 'ri-sun-line', name: 'Özel Plaj', description: 'VIP plaj bölümü' },
    ],
    activities: [
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Profesyonel golf kursu' },
      { icon: 'ri-spa-line', name: 'Spa Ritüelleri', description: 'Özel spa programları' },
      { icon: 'ri-ship-line', name: 'Yat Turu', description: 'Özel tekne gezisi' },
      { icon: 'ri-wine-line', name: 'Şarap Tadımı', description: 'Şarap mahzeni' },
    ],
  },
  {
    id: 18,
    facility_name: 'Titanic Deluxe Belek',
    location: 'Antalya - Belek',
    week_count: 2,
    createdAt: '2025-09-18',
    description:
      "Titanic Deluxe Belek'te 2 haftalık devremülk hakkı. Belek'in en popüler tesislerinden. Geniş aquapark, özel plaj ve zengin animasyon programı.",
    images: [
      'https://readdy.ai/api/search-image?query=titanic%20deluxe%20belek%20antalya%20luxury%20resort%20hotel%20beach%20pools%20aquapark%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=titanic-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=titanic%20deluxe%20belek%20family%20room%20spacious%20interior%20sea%20view%20balcony%20modern%20furniture%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=titanic-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=titanic%20deluxe%20belek%20aquapark%20water%20slides%20pools%20family%20fun%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=titanic-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=titanic%20deluxe%20belek%20antalya%20luxury%20resort%20hotel%20beach%20pools%20aquapark%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=titanic-real-1&orientation=landscape',
    price: 3100000,
    contact_phone: '+90 533 999 0011',
    contact_whatsapp: '+90 533 999 0011',
    season: 'Yaz Sezonu',
    unit_type: 'Aile Odası',
    capacity: 4,
    owner_name: 'Ce*** A***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Aquapark', description: 'Dev su parkı' },
      { icon: 'ri-sun-line', name: 'Plaj', description: 'Geniş kumsal' },
      { icon: 'ri-gamepad-line', name: 'Çocuk Kulübü', description: 'Zengin aktivite programı' },
      { icon: 'ri-restaurant-line', name: 'Her Şey Dahil', description: '9 restoran' },
      { icon: 'ri-music-2-line', name: 'Animasyon', description: 'Profesyonel animasyon ekibi' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Spa ve wellness' },
    ],
    activities: [
      { icon: 'ri-basketball-line', name: 'Spor', description: 'Çok çeşitli spor aktiviteleri' },
      { icon: 'ri-music-2-line', name: 'Şovlar', description: 'Gece gösterileri' },
      { icon: 'ri-sailboat-line', name: 'Su Sporları', description: 'Motorlu ve motorsuz su sporları' },
      { icon: 'ri-shopping-bag-line', name: 'Alışveriş', description: 'Tesis içi butikler' },
    ],
  },
  {
    id: 19,
    facility_name: 'Delphin Imperial',
    location: 'Antalya - Lara',
    week_count: 1,
    createdAt: '2025-09-20',
    description:
      "Delphin Imperial'de 1 haftalık devremülk hakkı. Lara'nın en büyük tesislerinden. Aquapark, özel plaj ve zengin eğlence seçenekleri.",
    images: [
      'https://readdy.ai/api/search-image?query=delphin%20imperial%20lara%20antalya%20luxury%20resort%20hotel%20beach%20pools%20aquapark%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=delphin-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=delphin%20imperial%20deluxe%20room%20sea%20view%20balcony%20modern%20furniture%20lara%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=delphin-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=delphin%20imperial%20aquapark%20water%20slides%20pools%20entertainment%20lara%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=delphin-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=delphin%20imperial%20lara%20antalya%20luxury%20resort%20hotel%20beach%20pools%20aquapark%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=delphin-real-1&orientation=landscape',
    price: 2700000,
    contact_phone: '+90 534 111 2233',
    contact_whatsapp: '+90 534 111 2233',
    season: 'Yaz Sezonu',
    unit_type: 'Deluxe Oda',
    capacity: 3,
    owner_name: 'Fa*** S***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Aquapark', description: 'Büyük su parkı' },
      { icon: 'ri-sun-line', name: 'Plaj', description: 'Uzun kumsal' },
      { icon: 'ri-gamepad-line', name: 'Çocuk Kulübü', description: 'Animasyon programı' },
      { icon: 'ri-restaurant-line', name: 'Her Şey Dahil', description: '8 restoran, 9 bar' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Spa merkezi' },
      { icon: 'ri-music-2-line', name: 'Eğlence', description: 'Gece şovları' },
    ],
    activities: [
      { icon: 'ri-basketball-line', name: 'Spor', description: 'Tenis, voleybol, futbol' },
      { icon: 'ri-music-2-line', name: 'Animasyon', description: 'Gündüz ve gece aktiviteleri' },
      { icon: 'ri-sailboat-line', name: 'Su Sporları', description: 'Çeşitli su aktiviteleri' },
      { icon: 'ri-shopping-bag-line', name: 'Alışveriş', description: 'Tesis içi butikler' },
    ],
  },
  {
    id: 20,
    facility_name: 'Kaya Palazzo Golf Resort',
    location: 'Antalya - Belek',
    week_count: 2,
    createdAt: '2025-09-22',
    description:
      "Kaya Palazzo Golf Resort'ta 2 haftalık devremülk hakkı. Belek'in lüks tesislerinden. Golf sahası, özel plaj ve butik otel konsepti.",
    images: [
      'https://readdy.ai/api/search-image?query=kaya%20palazzo%20golf%20resort%20belek%20antalya%20luxury%20hotel%20golf%20course%20pools%20beach%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=kaya-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=kaya%20palazzo%20suite%20room%20elegant%20interior%20sea%20view%20balcony%20modern%20design%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=kaya-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=kaya%20palazzo%20golf%20course%20green%20fairway%20palm%20trees%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=kaya-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=kaya%20palazzo%20golf%20resort%20belek%20antalya%20luxury%20hotel%20golf%20course%20pools%20beach%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=kaya-real-1&orientation=landscape',
    price: 3600000,
    contact_phone: '+90 534 222 3344',
    contact_whatsapp: '+90 534 222 3344',
    season: 'Yaz Sezonu',
    unit_type: 'Suite Oda',
    capacity: 2,
    owner_name: 'Gü*** P***',
    amenities: [
      { icon: 'ri-golf-ball-line', name: 'Golf Sahası', description: '18 delikli saha' },
      { icon: 'ri-sun-line', name: 'Özel Plaj', description: 'Butik plaj' },
      { icon: 'ri-restaurant-2-line', name: 'Gourmet', description: 'A la carte restoranlar' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Lüks spa merkezi' },
      { icon: 'ri-vip-crown-line', name: 'VIP Hizmet', description: 'Özel hizmet' },
      { icon: 'ri-cocktail-line', name: 'Bar', description: 'Premium içecekler' },
    ],
    activities: [
      { icon: 'ri-golf-ball-line', name: 'Golf', description: 'Golf dersleri' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Özel spa programları' },
      { icon: 'ri-ship-line', name: 'Tekne Turu', description: 'Özel tekne gezisi' },
      { icon: 'ri-wine-line', name: 'Şarap Tadımı', description: 'Şarap seçkisi' },
    ],
  },
  {
    id: 21,
    facility_name: 'Susesi Luxury Resort',
    location: 'Antalya - Belek',
    week_count: 1,
    createdAt: '2025-09-25',
    description:
      "Susesi Luxury Resort'ta 1 haftalık devremülk hakkı. Belek'in en yeni lüks tesislerinden. Modern mimari, özel plaj ve yenilikçi konsept.",
    images: [
      'https://readdy.ai/api/search-image?query=susesi%20luxury%20resort%20belek%20antalya%20modern%20hotel%20architecture%20beach%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=susesi-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=susesi%20luxury%20resort%20modern%20room%20design%20sea%20view%20balcony%20elegant%20furniture%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=susesi-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=susesi%20luxury%20resort%20infinity%20pool%20sea%20view%20modern%20design%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=susesi-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=susesi%20luxury%20resort%20belek%20antalya%20modern%20hotel%20architecture%20beach%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=1200&height=800&seq=susesi-real-1&orientation=landscape',
    price: 4200000,
    contact_phone: '+90 534 333 4455',
    contact_whatsapp: '+90 534 333 4455',
    season: 'Yaz Sezonu',
    unit_type: 'Deluxe Oda',
    capacity: 2,
    owner_name: 'Le*** V***',
    amenities: [
      { icon: 'ri-sun-line', name: 'Özel Plaj', description: 'Modern plaj konsepti' },
      { icon: 'ri-water-flash-line', name: 'Infinity Pool', description: 'Sonsuzluk havuzu' },
      { icon: 'ri-restaurant-2-line', name: 'Gourmet', description: 'Fusion mutfak' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Modern spa merkezi' },
      { icon: 'ri-music-2-line', name: 'Beach Club', description: 'DJ performansları' },
      { icon: 'ri-cocktail-line', name: 'Bar', description: 'Signature kokteyller' },
    ],
    activities: [
      { icon: 'ri-music-2-line', name: 'Beach Party', description: 'Plaj partileri' },
      { icon: 'ri-sailboat-line', name: 'Su Sporları', description: 'Modern su sporları' },
      { icon: 'ri-spa-line', name: 'Wellness', description: 'Yoga ve meditasyon' },
      { icon: 'ri-camera-line', name: 'Fotoğraf', description: 'Instagram noktaları' },
    ],
  },
  {
    id: 22,
    facility_name: 'Adam & Eve Hotel',
    location: 'Antalya - Belek',
    week_count: 2,
    createdAt: '2025-09-28',
    description:
      "Adam & Eve Hotel'de 2 haftalık devremülk hakkı. Belek'in yetişkinlere özel lüks tesisi. Romantik atmosfer, özel plaj ve premium hizmet.",
    images: [
      'https://readdy.ai/api/search-image?query=adam%20eve%20hotel%20belek%20antalya%20adults%20only%20luxury%20resort%20romantic%20atmosphere%20beach%20pools%20palm%20trees%20turkey%20real%20photo&width=1200&height=800&seq=adameve-real-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=adam%20eve%20hotel%20romantic%20suite%20room%20elegant%20interior%20king%20bed%20modern%20design%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=adameve-real-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=adam%20eve%20hotel%20romantic%20dinner%20beach%20sunset%20candles%20elegant%20atmosphere%20belek%20antalya%20turkey%20real%20photo&width=1200&height=800&seq=adameve-real-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=adam%20eve%20hotel%20belek%20antalya%20adults%20only%20luxury%20resort%20romantic%20atmosphere%20beach%20pools%20palm%20trees%20turkey%20real%20photo&width=1200&height=800&seq=adameve-real-1&orientation=landscape',
    price: 3900000,
    contact_phone: '+90 534 444 5566',
    contact_whatsapp: '+90 534 444 5566',
    season: 'Yaz Sezonu',
    unit_type: 'Suite Oda',
    capacity: 2,
    owner_name: 'Ni*** H***',
    amenities: [
      { icon: 'ri-heart-line', name: 'Yetişkinlere Özel', description: '16+ konsept' },
      { icon: 'ri-sun-line', name: 'Özel Plaj', description: 'Romantik plaj' },
      { icon: 'ri-restaurant-2-line', name: 'Gourmet', description: 'Romantik restoranlar' },
      { icon: 'ri-spa-line', name: 'Spa', description: 'Çift spa programları' },
      { icon: 'ri-cocktail-line', name: 'Bar', description: 'Premium içecekler' },
      { icon: 'ri-music-2-line', name: 'Eğlence', description: 'Canlı müzik' },
    ],
    activities: [
      { icon: 'ri-heart-2-line', name: 'Romantik Akşam', description: 'Özel yemekler' },
      { icon: 'ri-ship-line', name: 'Tekne Turu', description: 'Günbatımı gezisi' },
      { icon: 'ri-spa-line', name: 'Çift Masajı', description: 'Spa ritüelleri' },
      { icon: 'ri-wine-line', name: 'Şarap Tadımı', description: 'Şarap geceleri' },
    ],
  },

  // Yeni Emin Termal İlanları - Şubat 2026
  {
    id: 23,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2026-02-13',
    contractDate: '13/02/2026',
    description:
      "Emin Termal'de 1 haftalık devremülk hakkı. Standart oda, termal havuz, spa hizmetleri dahil. Şifalı termal suları ile sağlıklı tatil fırsatı.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20standard%20room%20comfortable%20bed%20modern%20interior%20balcony%20garden%20view%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-hc-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20indoor%20thermal%20pool%20relaxation%20area%20warm%20water%20steam%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-hc-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20spa%20wellness%20center%20massage%20treatment%20relaxation%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-hc-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20standard%20room%20comfortable%20bed%20modern%20interior%20balcony%20garden%20view%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-hc-1&orientation=landscape',
    price: 8750000,
    contact_phone: '+90 535 111 2233',
    contact_whatsapp: '+90 535 111 2233',
    season: 'Tüm Sezon',
    unit_type: 'Standart Oda',
    capacity: 2,
    owner_name: 'Al*** Os*** V***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı ve açık havuz erişimi' },
      { icon: 'ri-spa-line', name: 'Spa Merkezi', description: 'Profesyonel masaj ve bakım hizmetleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Açık büfe kahvaltı dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Yüksek hızlı internet' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Ücretsiz kapalı otopark' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Fin saunası ve buhar odası' },
    ],
    activities: [
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova ormanlarında turlar' },
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-mental-health-line', name: 'Yoga', description: 'Sabah yoga seansları' },
      { icon: 'ri-bike-line', name: 'Bisiklet Turu', description: 'Çevrede doğa yürüyüşleri' },
    ],
  },
  {
    id: 24,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2026-02-08',
    contractDate: '08/02/2026',
    description:
      "Emin Termal'de 1 haftalık ultra lüks devremülk hakkı. Deluxe oda, özel termal jakuzi ve VIP spa hizmetleri dahil. En üst düzey termal tatil deneyimi.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20deluxe%20room%20luxury%20interior%20king%20bed%20elegant%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-ei-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20spa%20massage%20treatment%20room%20wellness%20center%20real%20photo%20turkey&width=1200&height=800&seq=emin-ei-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20jacuzzi%20bathroom%20luxury%20design%20real%20photo%20turkey&width=1200&height=800&seq=emin-ei-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20deluxe%20room%20luxury%20interior%20king%20bed%20elegant%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-ei-1&orientation=landscape',
    price: 15000000,
    contact_phone: '+90 535 222 3344',
    contact_whatsapp: '+90 535 222 3344',
    season: 'Tüm Sezon',
    unit_type: 'Deluxe Oda',
    capacity: 2,
    owner_name: 'En*** İ***',
    amenities: [
      { icon: 'ri-vip-crown-line', name: 'VIP Hizmet', description: '24 saat özel hizmetli' },
      { icon: 'ri-drop-line', name: 'Özel Jakuzi', description: 'Odada termal jakuzi' },
      { icon: 'ri-spa-line', name: 'Spa Paketi', description: 'Sınırsız spa kullanımı' },
      { icon: 'ri-restaurant-2-line', name: 'Tam Pansiyon', description: '3 öğün yemek dahil' },
      { icon: 'ri-car-line', name: 'VIP Transfer', description: 'Lüks araç hizmeti' },
      { icon: 'ri-gift-line', name: 'Premium Paket', description: 'Tüm hizmetler dahil' },
    ],
    activities: [
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-mental-health-line', name: 'Wellness', description: 'Kişisel wellness programı' },
      { icon: 'ri-spa-line', name: 'Spa Ritüelleri', description: 'Özel spa programları' },
      { icon: 'ri-wine-line', name: 'Şarap Tadımı', description: 'Özel şarap mahzeni' },
    ],
  },
  {
    id: 25,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 2,
    createdAt: '2026-02-08',
    contractDate: '08/02/2026',
    description:
      "Emin Termal'de 2 haftalık devremülk hakkı. Deluxe oda, termal havuz erişimi ve spa hizmetleri dahil. Şifalı termal suları ile sağlıklı tatil fırsatı.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20deluxe%20room%20comfortable%20bed%20modern%20interior%20balcony%20garden%20view%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-es-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20indoor%20thermal%20pool%20relaxation%20area%20warm%20water%20steam%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-es-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20spa%20wellness%20center%20massage%20treatment%20relaxation%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-es-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20deluxe%20room%20comfortable%20bed%20modern%20interior%20balcony%20garden%20view%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-es-1&orientation=landscape',
    price: 5500000,
    contact_phone: '+90 535 333 4455',
    contact_whatsapp: '+90 535 333 4455',
    season: 'Tüm Sezon',
    unit_type: 'Deluxe Oda',
    capacity: 2,
    owner_name: 'Er*** S***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı ve açık havuz erişimi' },
      { icon: 'ri-spa-line', name: 'Spa Merkezi', description: 'Profesyonel masaj ve bakım hizmetleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Açık büfe kahvaltı dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Yüksek hızlı internet' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Ücretsiz kapalı otopark' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Fin saunası ve buhar odası' },
    ],
    activities: [
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova ormanlarında turlar' },
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-mental-health-line', name: 'Yoga', description: 'Sabah yoga seansları' },
      { icon: 'ri-bike-line', name: 'Bisiklet Turu', description: 'Çevrede doğa yürüyüşleri' },
    ],
  },
  {
    id: 26,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2026-02-08',
    contractDate: '08/02/2026',
    description:
      "Emin Termal'de 1 haftalık devremülk hakkı. Ekonomik fiyatla termal tatil fırsatı. Şifalı sular, sauna ve temel spa hizmetleri dahil.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20standard%20room%20clean%20modern%20design%20comfortable%20bed%20simple%20elegant%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-ag-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20thermal%20pool%20area%20guests%20relaxing%20warm%20water%20wellness%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-ag-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20sauna%20steam%20room%20relaxation%20wellness%20area%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-ag-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20standard%20room%20clean%20modern%20design%20comfortable%20bed%20simple%20elegant%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-ag-1&orientation=landscape',
    price: 2800000,
    contact_phone: '+90 535 444 5566',
    contact_whatsapp: '+90 535 444 5566',
    season: 'Tüm Sezon',
    unit_type: 'Standart Oda',
    capacity: 2,
    owner_name: 'Ay*** G***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı termal havuz' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Geleneksel Türk hamamı' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Kahvaltı dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Odada internet erişimi' },
      { icon: 'ri-tv-line', name: 'TV', description: 'Uydu yayınlı LCD tv' },
    ],
    activities: [
      { icon: 'ri-heart-pulse-line', name: 'Termal Banyo', description: 'Şifalı termal su seansları' },
      { icon: 'ri-cup-line', name: 'Çay Saati', description: 'Geleneksel Türk çayı keyfi' },
      { icon: 'ri-walk-line', name: 'Yürüyüş', description: 'Çevrede doğa yürüyüşleri' },
      { icon: 'ri-book-read-line', name: 'Dinlenme', description: 'Huzurlu tatil ortamı' },
    ],
  },
  {
    id: 27,
    facility_name: 'Çınar Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2026-02-26',
    contractDate: '26/02/2026',
    description:
      "Çınar Termal'de 1 haftalık devremülk hakkı. 1+1 4 kişilik oda, termal havuz ve spa hizmetleri dahil. Şifalı termal suları ile sağlıklı ve huzurlu tatil fırsatı.",
    images: [
      'https://readdy.ai/api/search-image?query=cinar%20termal%20yalova%20thermal%20hotel%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20turkey%20real%20photo&width=1200&height=800&seq=cinar-aov-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinar%20termal%20yalova%20hotel%20room%201%20plus%201%20apartment%20interior%20comfortable%20beds%20modern%20furniture%20clean%20design%20turkey%20real%20photo&width=1200&height=800&seq=cinar-aov-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinar%20termal%20yalova%20outdoor%20thermal%20pool%20garden%20trees%20relaxation%20area%20hotel%20real%20photo%20turkey&width=1200&height=800&seq=cinar-aov-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=cinar%20termal%20yalova%20thermal%20hotel%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20turkey%20real%20photo&width=1200&height=800&seq=cinar-aov-1&orientation=landscape',
    price: 5000000,
    contact_phone: '',
    contact_whatsapp: '',
    season: 'Tüm Sezon',
    unit_type: '1+1 Daire',
    capacity: 4,
    owner_name: 'Al*** Os*** V***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı ve açık termal havuzlar' },
      { icon: 'ri-spa-line', name: 'Spa Merkezi', description: 'Profesyonel masaj ve bakım hizmetleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Açık büfe kahvaltı dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Tüm alanlarda yüksek hızlı internet' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Ücretsiz kapalı otopark' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Fin saunası ve buhar odası' },
    ],
    activities: [
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova ormanlarında rehberli turlar' },
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-mental-health-line', name: 'Yoga & Meditasyon', description: 'Sabah yoga seansları' },
      { icon: 'ri-bike-line', name: 'Bisiklet Turu', description: 'Çevredeki köylere bisiklet gezileri' },
    ],
  },
  {
    id: 28,
    facility_name: 'Pınar Termal',
    location: 'Yalova',
    week_count: 2,
    createdAt: '2026-02-26',
    contractDate: '26/02/2026',
    description:
      "Pınar Termal'de 2 haftalık devremülk hakkı. 1+1 4 kişilik oda, termal havuz, sauna ve spa hizmetleri dahil. Ailenizle birlikte şifalı termal sularda unutulmaz tatil.",
    images: [
      'https://readdy.ai/api/search-image?query=pinar%20termal%20yalova%20thermal%20hotel%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20turkey%20real%20photo&width=1200&height=800&seq=pinar-aov-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=pinar%20termal%20yalova%20hotel%20apartment%201%20plus%201%20room%20interior%20comfortable%20beds%20living%20area%20modern%20furniture%20turkey%20real%20photo&width=1200&height=800&seq=pinar-aov-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=pinar%20termal%20yalova%20outdoor%20thermal%20pool%20garden%20relaxation%20area%20families%20hotel%20real%20photo%20turkey&width=1200&height=800&seq=pinar-aov-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=pinar%20termal%20yalova%20thermal%20hotel%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20turkey%20real%20photo&width=1200&height=800&seq=pinar-aov-1&orientation=landscape',
    price: 5000000,
    contact_phone: '',
    contact_whatsapp: '',
    season: 'Tüm Sezon',
    unit_type: '1+1 Daire',
    capacity: 4,
    owner_name: 'Al*** Os*** V***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı ve açık termal havuzlar' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Geleneksel Türk hamamı ve fin saunası' },
      { icon: 'ri-spa-line', name: 'Spa Merkezi', description: 'Masaj ve bakım hizmetleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Kahvaltı ve akşam yemeği dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Tüm alanlarda internet erişimi' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Ücretsiz otopark' },
    ],
    activities: [
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova ormanlarında turlar' },
      { icon: 'ri-mental-health-line', name: 'Yoga', description: 'Sabah yoga seansları' },
      { icon: 'ri-cup-line', name: 'Çay Saati', description: 'Geleneksel Türk çayı keyfi' },
    ],
  },
  {
    id: 29,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 4,
    createdAt: '2026-02-26',
    contractDate: '26/02/2026',
    description:
      "Emin Termal'de 4 haftalık devremülk hakkı. 1+1 daire, tüm termal havuzlara sınırsız erişim ve kapsamlı spa hizmetleri dahil. Uzun süreli sağlıklı tatil için ideal fırsat.",
    images: [
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20complex%20aerial%20view%20buildings%20pools%20gardens%20lush%20greenery%20real%20photo%20turkey&width=1200&height=800&seq=emin-aov-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20apartment%201%20plus%201%20room%20interior%20living%20area%20comfortable%20beds%20modern%20furniture%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=emin-aov-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20multiple%20thermal%20pools%20spa%20area%20wellness%20relaxation%20guests%20real%20photo%20turkey&width=1200&height=800&seq=emin-aov-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=emin%20termal%20yalova%20hotel%20complex%20aerial%20view%20buildings%20pools%20gardens%20lush%20greenery%20real%20photo%20turkey&width=1200&height=800&seq=emin-aov-1&orientation=landscape',
    price: 10000000,
    contact_phone: '',
    contact_whatsapp: '',
    season: 'Tüm Sezon',
    unit_type: '1+1 Daire',
    capacity: 4,
    owner_name: 'Al*** Os*** V***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Sınırsız Termal', description: 'Tüm havuzlara sınırsız erişim' },
      { icon: 'ri-spa-line', name: 'Spa Paketi', description: 'Haftalık masaj dahil' },
      { icon: 'ri-restaurant-line', name: 'Tam Pansiyon', description: '3 öğün yemek dahil' },
      { icon: 'ri-shirt-line', name: 'Çamaşırhane', description: 'Ücretsiz çamaşır hizmeti' },
      { icon: 'ri-first-aid-kit-line', name: 'Sağlık Kontrolü', description: 'Haftalık doktor viziti' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Uzun süreli park imkanı' },
    ],
    activities: [
      { icon: 'ri-heart-pulse-line', name: 'Kür Programı', description: '21 günlük termal kür' },
      { icon: 'ri-run-line', name: 'Fitness', description: 'Kişisel antrenör desteği' },
      { icon: 'ri-mental-health-line', name: 'Detoks', description: 'Kapsamlı detoks programı' },
      { icon: 'ri-user-heart-line', name: 'Diyet Danışmanlığı', description: 'Beslenme uzmanı desteği' },
    ],
  },
  {
    id: 30,
    facility_name: 'Emin Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2026-02-17',
    contractDate: '17/02/2026',
    description:
      "Emin Termal'de 1 haftalık devremülk hakkı. Termal havuz, sauna ve spa hizmetleri dahil. Şifalı termal suları ile sağlıklı ve huzurlu tatil fırsatı.",
    images: [
      'https://readdy.ai/api/search-image?query=thermal%20hotel%20yalova%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20comfortable%20room%20turkey%20real%20photo&width=1200&height=800&seq=bilal-eren-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=thermal%20hotel%20yalova%20standard%20room%20comfortable%20bed%20modern%20interior%20clean%20design%20balcony%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=bilal-eren-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=thermal%20hotel%20yalova%20outdoor%20pool%20garden%20relaxation%20area%20guests%20wellness%20real%20photo%20turkey&width=1200&height=800&seq=bilal-eren-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=thermal%20hotel%20yalova%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20comfortable%20room%20turkey%20real%20photo&width=1200&height=800&seq=bilal-eren-1&orientation=landscape',
    price: 700000,
    contact_phone: '',
    contact_whatsapp: '',
    season: 'Tüm Sezon',
    unit_type: 'Standart Oda',
    capacity: 2,
    owner_name: 'Bi*** Er***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı ve açık termal havuzlar' },
      { icon: 'ri-spa-line', name: 'Spa Merkezi', description: 'Profesyonel masaj ve bakım hizmetleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Açık büfe kahvaltı dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Tüm alanlarda yüksek hızlı internet' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Ücretsiz kapalı otopark' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Fin saunası ve buhar odası' },
    ],
    activities: [
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova ormanlarında rehberli turlar' },
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-mental-health-line', name: 'Yoga & Meditasyon', description: 'Sabah yoga seansları' },
      { icon: 'ri-bike-line', name: 'Bisiklet Turu', description: 'Çevredeki köylere bisiklet gezileri' },
    ],
  },
  {
    id: 31,
    facility_name: 'Hattuşa Termal',
    location: 'Yalova',
    week_count: 1,
    createdAt: '2026-02-21',
    contractDate: '21/02/2026',
    description:
      "Hattuşa Termal'de 1 haftalık devremülk hakkı. Termal havuz, sauna ve spa hizmetleri dahil. Şifalı termal suları ile sağlıklı ve huzurlu tatil fırsatı.",
    images: [
      'https://readdy.ai/api/search-image?query=hattusa%20termal%20yalova%20thermal%20hotel%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20turkey%20real%20photo&width=1200&height=800&seq=hattusa-te-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hattusa%20termal%20yalova%20hotel%20room%20comfortable%20bed%20modern%20interior%20clean%20design%20balcony%20garden%20view%20real%20hotel%20photo%20turkey&width=1200&height=800&seq=hattusa-te-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=hattusa%20termal%20yalova%20outdoor%20pool%20garden%20relaxation%20area%20guests%20wellness%20real%20photo%20turkey&width=1200&height=800&seq=hattusa-te-3&orientation=landscape',
    ],
    cover_image:
      'https://readdy.ai/api/search-image?query=hattusa%20termal%20yalova%20thermal%20hotel%20indoor%20pool%20warm%20water%20steam%20wellness%20spa%20relaxation%20modern%20facility%20turkey%20real%20photo&width=1200&height=800&seq=hattusa-te-1&orientation=landscape',
    price: 1643625,
    contact_phone: '',
    contact_whatsapp: '',
    season: 'Tüm Sezon',
    unit_type: 'Standart Oda',
    capacity: 2,
    owner_name: 'Tu*** Ez***',
    amenities: [
      { icon: 'ri-water-flash-line', name: 'Termal Havuz', description: 'Kapalı ve açık termal havuzlar' },
      { icon: 'ri-spa-line', name: 'Spa Merkezi', description: 'Profesyonel masaj ve bakım hizmetleri' },
      { icon: 'ri-restaurant-line', name: 'Restoran', description: 'Açık büfe kahvaltı dahil' },
      { icon: 'ri-wifi-line', name: 'Ücretsiz WiFi', description: 'Tüm alanlarda yüksek hızlı internet' },
      { icon: 'ri-parking-box-line', name: 'Otopark', description: 'Ücretsiz kapalı otopark' },
      { icon: 'ri-fire-line', name: 'Sauna', description: 'Fin saunası ve buhar odası' },
    ],
    activities: [
      { icon: 'ri-walk-line', name: 'Doğa Yürüyüşü', description: 'Yalova ormanlarında rehberli turlar' },
      { icon: 'ri-heart-pulse-line', name: 'Termal Kür', description: 'Şifalı su tedavi programları' },
      { icon: 'ri-mental-health-line', name: 'Yoga & Meditasyon', description: 'Sabah yoga seansları' },
      { icon: 'ri-bike-line', name: 'Bisiklet Turu', description: 'Çevredeki köylere bisiklet gezileri' },
    ],
  },
];
